import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { UsuarioTipo } from '@app/models/usuario-tipo.model';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-usuario-tipo-lista',
  templateUrl: './usuario-tipo-lista.component.html'
})
export class UsuarioTipoListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  filtroDescricao = '';
  paginacao: Paginacao = new Paginacao();
  lstUsuarioTipo: UsuarioTipo[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioTipoService: UsuarioTipoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.usuarioTipoService.obterPesquisa(descricao, pagina).toPromise().then(
      data => {
        this.lstUsuarioTipo = data.Dados,
          this.paginacao.totalDeItens = data.Total;
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(usuarioTipo: UsuarioTipo) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir o tipo de usuário: ' + usuarioTipo.Descricao + '?';
    this.bsModalRef.content.confirmar = () => {
      this.usuarioTipoService.deletar(usuarioTipo.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        },
        (e: HttpErrorResponse) => {
          this.toastr.error(e.error);
        }
      );
    };
  }


  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
